export const OHIO = 'Ohio';
export const KENTUCKY = 'Kentucky';
export const FLORIDA = 'Florida';
export const ILLINOIS = 'Illinois';
export const NORTH_CAROLINA = 'North Carolina';
export const PENNSYLVANIA = 'Pennsylvania';
export const VALID_STATES = [ILLINOIS, OHIO, FLORIDA, NORTH_CAROLINA, PENNSYLVANIA, KENTUCKY];
export const DEGREE = 'Education';
export const ECE_DEGREE = 'ECE-Related Degree';
export const BASE_EDUCATION_OPTION_IDS = [-1, 0, null];
export const CDA = 'CDA';
export const YEARS_EXPERIENCE = 'Years Experience';
export const NEW_TO_CHILDCARE = { key: -1, value: 'New to Childcare (0-1 year)' };
export const NO_EDUCATION_REQUIRED_CHOICE = { key: -1, value: 'No Education Required' };

export const CLUMPED_YOE = [
    NEW_TO_CHILDCARE,
    { key: 1, value: 'Intermediate Experience (1-5 years)' },
    { key: 5, value: 'Very Experienced (5+ years)' },
];
export const valid_states_yoe_choices = VALID_STATES.map((state) => [state, CLUMPED_YOE]);
export const YOE_CHOICES_BY_STATE = {
    ...Object.fromEntries(valid_states_yoe_choices),
    [NORTH_CAROLINA]: CLUMPED_YOE.slice(1, 3),
};

export const MINIMUM_WAGE_BY_STATE = {
    [OHIO]: 11,
    [FLORIDA]: 15,
    [ILLINOIS]: 15,
    [NORTH_CAROLINA]: 11,
    [PENNSYLVANIA]: 11,
    [KENTUCKY]: 11,
};

// NOTE: Role (Lead Teacher or Assistant Teacher) qualification id
export const NORTH_CAROLINA_ROLE_ID = 67;
export const PENNSYLVANIA_ROLE_ID = 94;
export const ILLINOIS_ROLE_ID = 100;
export const FLORIDA_45_HOURS_ID = 18;
export const FLORIDA_VPK_CREDENTIAL_ID = 26;
export const FLORIDA_STAFF_CREDENTIAL_ID = 27;
export const FLORIDA_DIRECTOR_CREDENTIAL_ID = 28;
export const FL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS = [
    FLORIDA_45_HOURS_ID,
    FLORIDA_VPK_CREDENTIAL_ID,
    FLORIDA_STAFF_CREDENTIAL_ID,
    FLORIDA_DIRECTOR_CREDENTIAL_ID,
];

export const STATE_SPECIFIC_REQUIREMENTS_TO_EXCLUDE = [NORTH_CAROLINA_ROLE_ID];

// NOTE: first aid/cpr
export const IL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS = [43, 46];

// NOTE: cpl level
export const OH_SINGLE_QUALIFICATION_PROBLEM_CHOICE_IDS = [9];

export const GLOBAL_BOOLEAN_QUALIFICATION_PROBLEM_NAMES = ['CDA'];

export const OH_BOOLEAN_QUALIFICATION_PROBLEM_NAMES = ['Communicable Disease Initial Course'];

export const PA_BOOLEAN_QUALIFICATION_PROBLEM_NAMES = ['Certified Childcare Professional (CCP)', 'Director Credential'];

export const BOOL = 'BOOLEAN';
export const SINGLE = 'SINGLE_SELECT';
export const MULTI = 'MULTI_SELECT';

export const HIGH_SCHOOL = 'High School';
